[    {
        "display": "true",
        "ui_columnname": "CATReporterIMID",
        "db_columnname": "CATReporterIMID",
        "datatype": "String",
        "mappingkey": "catReporterIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },  
    {
        "display": "true",
        "ui_columnname": "Group",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Report Date",
        "db_columnname": "reportDate",
        "datatype": "date",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Panel Name",
        "db_columnname": "panelName",
        "datatype": "String",
        "mappingkey": "panelName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },  

    {
        "display": "true",
        "ui_columnname": "Table Name",
        "db_columnname": "tableName",
        "datatype": "String",
        "mappingkey": "tableName",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }, 

    {
        "display": "true",
        "ui_columnname": "Row Key",
        "db_columnname": "rowKey",
        "datatype": "String",
        "mappingkey": "rowKey",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }, 
    {
        "display": "true",
        "ui_columnname": "Column Key",
        "db_columnname": "columnKey",
        "datatype": "String",
        "mappingkey": "columnKey",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },   
    {
        "display": "true",
        "ui_columnname": "cellValue",
        "db_columnname": "cellValue",
        "datatype": "String",
        "mappingkey": "cellValue",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }, 
    {
        "display": "true",
        "ui_columnname": "Comment",
        "db_columnname": "comment",
        "datatype": "String",
        "mappingkey": "comment",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "Path",
        "db_columnname": "rowKey",
        "datatype": "String",
        "mappingkey": "rowKey",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "false",
        "ui_columnname": "Active",
        "db_columnname": "isActive",
        "datatype": "String",
        "mappingkey": "isActive",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Create Date",
        "db_columnname": "createdDate",
        "datatype": "String",
        "mappingkey": "createdDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Created By",
        "db_columnname": "createdBy",
        "datatype": "String",
        "mappingkey": "createdBy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Update Date",
        "db_columnname": "updatedDate",
        "datatype": "String",
        "mappingkey": "updatedDate",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "Updated By",
        "db_columnname": "updatedBy",
        "datatype": "String",
        "mappingkey": "updatedBy",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "",
        "dropdownvalue": ""
    }
]